module.exports = __webpack_public_path__ + "static/media/gg.e62cf11a.webp";